import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        isLogin: false,
        luyou: 1,
        userInfo: {},
        nCount: 0,
        report:"",
        api: 'https://pbl.cocorobo.cn/api/pbl/',
        // fileApi: 'http://localhost:7004/file/',
        // fileApi: 'http://10.3.16.166:7004/file/',
        fileApi: 'https://r2rapi.cocorobo.cn/file/',
        socket: "https://poll.cocorobo.cn",
        // socket: "http://localhost:1473",
        // api: 'http://localhost:7003/api/pbl/',
    },

    mutations: {
        update(state, [key, value]) {
            state[key] = value;
        },
    }
})

export default store


// WEBPACK FOOTER //
// ./src/config/config.js